import * as React from 'react';

const CircleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="circle_svg__eds-icon--circle_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="circle_svg__eds-icon--circle_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9m0-1C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2"
        />
    </svg>
);

CircleSvg.displayName = 'CircleSvg';
export default CircleSvg;
